// extracted by mini-css-extract-plugin
export default {"servicesItem":"ServicesItem_servicesItem__mQhY-","servicesImg":"ServicesItem_servicesImg__MegLy","servicesDescription":"ServicesItem_servicesDescription__i76hM"};